import script from "./ViewArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewArticle.vue?vue&type=script&setup=true&lang=js"

import "./ViewArticle.vue?vue&type=style&index=0&id=0bb4a792&scoped=true&lang=css"
import "./ViewArticle.vue?vue&type=style&index=1&id=0bb4a792&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb4a792"]])

export default __exports__